var map = {
	"./dress0.webp": 1504,
	"./dress1.webp": 3715,
	"./dress10.webp": 7093,
	"./dress11.webp": 2922,
	"./dress12.webp": 5291,
	"./dress13.webp": 568,
	"./dress14.webp": 3473,
	"./dress2.webp": 2994,
	"./dress3.webp": 9405,
	"./dress4.webp": 8332,
	"./dress5.webp": 1775,
	"./dress6.webp": 9326,
	"./dress7.webp": 9049,
	"./dress8.webp": 1496,
	"./dress9.webp": 4315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4258;